<!--
 * @Descripttion: 支付二维码弹窗
 * @version: 1.0
 * @program: django-vue-lyadmin
 * @Author: lybbn
 * @Date: 2024.08.07
-->
<template>
	<LyDialog :hidden="hidden" :title="!!title?title:(payMode==0?'支付宝支付':'微信支付')" :width="dialogWidth" :height="dialogHeight" @close="handelClose">
        <div class="qrcode-wrapper">
            <div class="qrcode-wrap">
                <LyQrcode :text="qrcodeContent" :size="size" :logo="payMode == 0 ? alipaylogo : wechatlogo"/>
            </div>
            <div class="tips">
                <div>请使用<span class="platform">{{payMode == 0 ? '支付宝' : '微信'}}</span>扫描</div>
                <div>二维码完成支付</div>
            </div>
        </div>
    </LyDialog>
</template>

<script setup>
    import LyDialog from "@/components/dialog/lydialog.vue";
    import LyQrcode from "@/components/qrcode/lyqrcode.vue";

    const emits = defineEmits(['closed'])

    import alipaylogo from '@/assets/img/pay/alipay-logo.png';
    import wechatlogo from '@/assets/img/pay/wechat-logo.png';

	const props = defineProps({
        hidden: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        dialogWidth: {
            type: Number,
            default: 370
        },
        dialogHeight: {
            type: Number,
            default: 400
        },
        size: {
            type: Number,
            default: 290
        },
        qrcodeContent:{
            type: String,
            default: ""
        },
        payMode:{
            type: Number,
            default: 0
        },
    })

    function handelClose(){
        emits('closed')
    }
	
</script>

<style lang="scss" scoped>
.qrcode-wrapper {
    width: 100%;

    .qrcode-wrap {
        width: 290px;
        height: 290px;
        position: relative;
        margin: 30px auto 10px;

        .qrcode {
            width: 100%;
            height: 100%;
        }
    
    }

    .tips {
        margin-bottom: 10px;
        color: var(--ly-text-color);
        text-align: center;

        .platform {
            color: var(--el-color-primary);
            margin: 0 5px;
        }
    }
}
</style>
